export default __webpack_public_path__ + "static/media/0xcd1faff6e578fa5cac469d2418c95671ba1a62fe.fca50f67.svg";